export enum Roles {
    Codalt = 'codalt',
    Convert = 'convert',
    Customer = 'customer',
    Drawer = 'drawer',
    Management = 'management',
    Manager = 'manager',
    Productowner = 'productowner',
    UserManagement = 'userManagement',
    Vakman = 'vakman',
    Workplanner = 'workplanner',
}
